import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';

const NONE_ISSUER_CALL = ['NONE', 'ISSUER_CALL'];
export const PRODUCT_CALL_EVENT_TYPES = new Map<ProductTypeEnum, string[]>([
  [ProductTypeEnum.AUTOCALL, ['AUTOCALL']],
  [ProductTypeEnum.AUTOCALL_GROWTH_AT_MATURITY, ['AUTOCALL']],
  [ProductTypeEnum.CLN, NONE_ISSUER_CALL],
  [
    ProductTypeEnum.FIXED_TO_FLOATING_FLOATING_TO_FIXED_RATE_NOTE,
    NONE_ISSUER_CALL,
  ],
  [ProductTypeEnum.FIXED_RATE_NOTE, NONE_ISSUER_CALL],
  [
    ProductTypeEnum.FLOATING_RATE_NOTE,
    [
      ...NONE_ISSUER_CALL,
      'TARGET_REDEMPTION', // TODO: Still waiting for Stuart/James/Ben to confirm
    ],
  ],
  [ProductTypeEnum.EQ_ISSUER_CALLABLE, ['ISSUER_CALL']],
  [ProductTypeEnum.CHOOSER, NONE_ISSUER_CALL],
  [ProductTypeEnum.RANGE_ACCRUAL, NONE_ISSUER_CALL],
]);
